import {IncomingHttpHeaders} from "node:http";

export const prepareSsrHeaders = (headers: Headers, requestHeaders?: IncomingHttpHeaders) => {
    // Pass Cookie header to API
    if (requestHeaders?.cookie) {
        headers.set("Cookie", requestHeaders.cookie as string);
    }

    // Pass Referer header to API
    if (requestHeaders?.referer) {
        headers.set("Referer", requestHeaders.referer as string);
    }

    return headers;
};
